import { z } from 'zod';
export const HostnameSchema = z.string(); // home.eigtech.io
export const OwnerDomainsSchema = z.object({
    gatekeeperBaseUrl: HostnameSchema,
    csrUiBaseUrl: HostnameSchema,
    delegateUiBaseUrl: HostnameSchema,
    tplapUiBaseUrl: HostnameSchema,
    meetUiBaseUrl: HostnameSchema.optional(),
    shortUrlHostedZone: z.string().min(3),
});
